//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

// import WordCount from '../Highlights/WordCount';
import BackButtonHijack from '../BackButtonHijack';
import SmallLoadingWrapper from '../../../Loading/SmallLoadingWrapper';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';
import {
  closeOverviewModal,
  closeEditor,
} from '../../../../redux/actions/trekOverviewActions';
import { getToastMsg } from '../../../ErrorMessage';

import './description.css';

// const maxlength = 1500;

type Props = {
  trekId: string,
  description: string,
  closeEditor: () => void,
  renderedAsModal: boolean,
  closeOverviewModal: () => void,
  updateOverviewEdits: (obj: Object) => void,
  patchOverviewEdits: (trekId: string, obj: Object) => void,
};

type State = {
  description: string,
  loading: boolean,
};

class DescriptionEditor extends Component<Props, State> {
  static defaultProps = { description: '', renderedAsModal: false };

  state = { description: this.props.description, loading: false };

  render() {
    const { renderedAsModal, closeOverviewModal } = this.props;
    const { description, loading } = this.state;

    return (
      <div id="descritption-editor">
        <div className="d-mobile">
          <div className="d-flex justify-content-between">
            {renderedAsModal && (
              <a onClick={closeOverviewModal}>
                <i className="icon icon-hg-chev-left" aria-hidden="true" />
              </a>
            )}
            <h2>DESCRIPTION</h2>
          </div>
        </div>
        <SmallLoadingWrapper showLoading={loading}>
          <div className="row">
            <div className="col-12 save-btn">
              <a onClick={this.handleSave}>
                <i className="icon icon-hg-save" aria-hidden="true" /> Save
              </a>
            </div>
            {renderedAsModal && <BackButtonHijack close={closeOverviewModal} />}
            <div className="col-12 edit-textarea">
              <textarea
                // maxLength={maxlength}
                className="form-control"
                rows="10"
                value={description}
                onChange={this.handleChange}
              />
              {/* {description && (
                <WordCount maxChar={maxlength} charCount={this.state.description.length} />
              )} */}
            </div>
          </div>
        </SmallLoadingWrapper>
      </div>
    );
  }

  componentDidMount() {
    this.timeout = setTimeout(
      () => window.addEventListener('click', this.handleOutsideClick),
      10
    );
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  handleChange = e => this.setState({ description: e.target.value });

  setLoadingState = status => this.setState({ loading: status });

  handleSave = () => {
    let { description } = this.state;
    description = description.replace(/\.(\n)/gi, '.\n');
    const {
      updateOverviewEdits,
      patchOverviewEdits,
      closeOverviewModal,
      renderedAsModal,
      closeEditor,
      trekId,
    } = this.props;

    const patchObj = { long_overview: description };

    this.setLoadingState(true);

    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        updateOverviewEdits(patchObj);

        if (renderedAsModal) {
          closeOverviewModal();
        } else {
          closeEditor();
        }
        this.setLoadingState(false);
        getToastMsg({ status: 'success', type: 'changeTrekDescription' });
      })
      .catch(() => {
        this.setLoadingState(false);
        getToastMsg({ status: 'error', type: 'changeTrekDescription' });
      });
  };

  handleOutsideClick = e => {
    const { loading } = this.state;
    if (!document.getElementById('descritption-editor').contains(e.target))
      if (!loading) this.props.closeEditor();
  };
}

const mapStateToProps = ({ selectedTrek, trekOverview }) => ({
  description: selectedTrek.trek.long_overview,
  trekId: selectedTrek.trek.id,
  renderedAsModal: trekOverview.isModalOpen,
});

export default connect(
  mapStateToProps,
  {
    closeOverviewModal,
    closeEditor,
    patchOverviewEdits,
    updateOverviewEdits,
  }
)(DescriptionEditor);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Description/Description.jsx